<template>
  <div class="admin-header">

    <v-container fluid class="px-0">
      <v-row class="flex justify-space-between" no-gutters>
        <!-- Logo/Title Section -->

        <v-col cols="8" lg="6" align-self="center">
          <div class="d-flex align-start flex-column">
            <div class="d-flex align-center">
              <v-icon size="24" class="mr-2" color="primary">mdi-credit-card-outline</v-icon>
              <span class="font-roboto font-weight-medium text-h5">{{
                $t('message.transactions_admin_plus.transactions_header_title') }}</span>
            </div>
            <div class="font-roboto text-subtitle-1 plusGreyDarken1--text">{{
              $t('message.transactions_admin_plus.transactions_header_subtitle') }}</div>
          </div>
        </v-col>


        <!-- Actions Section -->
        <v-col cols="4" lg="6" align-self="center">
          <v-row cols="12" sm="6" md="4" no-gutters class="d-flex align-center justify-end">
            <v-col cols="auto" class="d-none d-lg-flex">

              <v-btn small outlined color="primary" @click="$emit('sell-item')" class="mr-5"
                :disabled="disabledActions">
                <span class="d-none d-md-inline">{{ $t('message.transactions_admin_plus.sell_item') }}</span>
              </v-btn>

              <v-btn small outlined color="primary" @click="$emit('go-to-new-event')" class="mr-5"
                :disabled="disabledActions">
                <span class="d-none d-md-inline">{{ $t('message.transactions_admin_plus.create_event') }}</span>
              </v-btn>

              <v-btn small outlined class=" plusIndigoDarken1 plusSurface--text"
                @click="$emit('detailed-report-dialog')" :disabled="disabledActions">
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t('message.transactions_admin_plus.transactions_header_download_short') }}</span>
              </v-btn>
            </v-col>

            <v-col cols="auto" class="d-flex d-lg-none justify-end" v-if="!disabledActions">
              <v-menu elevation="0" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn class="ml-5 rounded-sm" fab small outlined elevation="0" color="primary">
                      <v-icon size="20">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </span>
                </template>
                <v-list class="font-roboto text-body-1">

                  <v-list-item class="d-flex d-lg-none" v-if="!isSmallerDisplay()" @click="$emit('sell-item')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.transactions_admin_plus.sell_item') }}</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="d-flex d-lg-none" v-if="!isSmallerDisplay()" @click="$emit('go-to-new-event')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.transactions_admin_plus.create_event') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('add-new-expense')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.transactions_admin_plus.add_expense') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('detailed-report-dialog')">
                    <v-list-item-title class="clickable">
                      <span>{{ $t('message.transactions_admin_plus.download_report') }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  name: "ViewTransactionsHeader",
  props: {
    payingCount: {
      type: Number,
      default: 0,
    },
    freeCount: {
      type: Number,
      default: 0,
    },
    upcomingBirthdays: {
      type: [Array, Boolean],
      default: false,
    },
    messagesThread: {
      type: [Object, Boolean],
      default: false,
    },
    disabledActions: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'sell-item',
    'go-to-new-event',
    'detailed-report-dialog',
    'add-new-expense',
  ],
  methods: {
    isSmallerDisplay() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>

<style scoped>
.admin-header {
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--grey-lighten-2, #E0E0E0);
  padding-bottom: 1rem;
  height: auto;
  flex: 1;
}
</style>
